export default "__VITE_ASSET__DNzDE8Ct__"